// extracted by mini-css-extract-plugin
export default {"chivalry__img":"_Chivalry_chivalry__img__S22Rh"};